$(document).ready(function () {
    function getText(selector) {
        return $(selector).text().replace(/"/g, '').trim();
    }

    if (document.location.href.indexOf('/watch-free') > 1) {
        let ctaSel = '#hero-content .cta-box a.button[aa-link]';
        let ctaTextSel = ctaSel + ' .button__text';
        let titleSel = '.video__lock-slate-text';

        let heroSlideWrapper = $(ctaSel).closest('.hero__content-slide-wrapper');
        let heroTitle = heroSlideWrapper.find('.hero__grid h1');
        let _assettitle = getText(heroTitle);

        let data = $(ctaSel).attr('aa-link');
        if (data) {
            // Get aa-link parameters
            let d = data.split('|');
            let __ctaText = getText(ctaTextSel);

            // cta click
            $(ctaSel).bind('click', function (event) {
                CBS.Promises.Tracking.onLoad(function () {
                    try {
                        if (typeof om != 'undefined') {
                            om.trackAction('trackHubHero', {
                                assetTitle: _assettitle,
                                rowHeaderTitle: 'free hub hero',
                                screenName: '/hub/free_content/free-content-hub',
                                posColNum: '0', //"position within the hero with count starting from 0>",
                                posRowNum: '0', // the hero banner (if is clickable) would carry the “0” position since it is the first clickable asset on the page
                                contentBrand: 'na', // content brand would be set to “na” since no one brand would apply for the hub hero/marquee click
                                ctaText: __ctaText,
                            });
                        }
                    } catch (e) {
                        // prevent crash if omniture not loaded on dev environment
                    }
                });
            });
        }
    }
});
